import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { CustomerService } from '../../../core/customer/customer.service';
import { AuthService } from '../../../core/auth/auth.service';
import { CustomerModel } from '../../../core/customer/customer.model';

@Component({
  selector: 'verification',
  templateUrl: 'verification.component.html',
  styleUrls: ['verification.scss']
})
export class VerificationComponent {

  @Input('user')
  user: any;

  @Output('validated')
  validated = new EventEmitter<number>();

  private _nextPageTimeOut = 0;
  error: string = '';

  constructor(private router: Router,
  private auth: AuthService,
  private _customerService: CustomerService) {

  }

  goToPreviosPage(): void {
    //setTimeout(() => this.router.navigate(['juegos/carrito']), this._nextPageTimeOut);
  }

  sendEmail(): void {
    this._customerService.sendVerificationEmail()
      .subscribe(
      response => {
        console.log('Se envio el correo satisfactoriamente: ', response);
      },
      err => {
        console.error('charge error, ', err);
        //this.tipoNotificacion = false;
        //this._setError(true, 'Error', err);
      });
  }

  verifyUser(): void{

    //
    //this.validated.emit();
    //

    this.auth.login({
            username: this.user.username,
            password: this.user.password
          }).subscribe(() => {
              //this.signup.emit();
              this.validated.emit();
            },
            err => this.error = err);



    /*this._customerService.getCustomerByUsername()
      .subscribe(
        customer => {
         
          if(this.auth.user.active){
            this.validated.emit(this.auth.user.address ? -1 : 3);
            //this.validated.emit(3);
          }else{
            this.error = 'La cuenta no ha sido verificada';
          }
        },
        err => this.error = err
      );*/
  }
}



// WEBPACK FOOTER //
// /jenkins/jenkins/workspace/apppronosticos_install_s3_dev/src/app/juegos/components/verification/verification.component.ts